import { AlertProps, Checkbox, Dropdown, DropdownProps, Flex, Typography } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { FC, ReactNode, Ref, memo } from 'react';

import { AddressChangerBadgeAlertOrCard } from './AddressChangerBadgeAlertOrCard';

interface Props {
  isDropdownOpen: boolean;
  alert: ReactNode;
  alertType: AlertProps['type'];
  settingValue: boolean;
  dropdownWrapperRef: Ref<HTMLDivElement>;
  handleAutoRedirectingChange: (e: CheckboxChangeEvent) => void;
  onDropdownOpen: NonNullable<DropdownProps['onOpenChange']>;
}

export const AddressChangerBadgeDropdown: FC<Props> = memo(
  ({ isDropdownOpen, alert, alertType, dropdownWrapperRef, settingValue, onDropdownOpen, handleAutoRedirectingChange }) => {
    return (
      <>
        <Dropdown
          menu={{
            items: [
              {
                key: 'switch',
                style: { width: '100%', paddingInline: 10, paddingBlock: 0 },
                label: (
                  <Flex justify="flex-start" align="center" gap={ 4 } style={{ width: '100%' }}>
                    <Checkbox onChange={ handleAutoRedirectingChange } checked={ settingValue }/>
                    <Typography.Text type="secondary" strong style={{ fontSize: 12 }}>
                      Автоматичне опрацювання
                    </Typography.Text>
                  </Flex>
                )
              }
            ],
            style: {
              padding: 0,
              background: 'transparent',
              boxShadow: 'none',
              border: 'none',
              marginInline: -10,
              paddingInline: 2
            }
          }}
          placement="bottomLeft"
          open={ isDropdownOpen }
          onOpenChange={ onDropdownOpen }
          autoAdjustOverflow
          trigger={ [] }
          overlayStyle={{ padding: 0, background: 'transparent' }}
          dropdownRender={ (node) => (
            <AddressChangerBadgeAlertOrCard
              type={ alertType }
              content={
                <div ref={ dropdownWrapperRef } style={{ width: '100%' }}>
                  { node }
                </div>
              }
              boxShadow
            />
          ) }
        >
          <div>{ alert }</div>
        </Dropdown>
      </>
    );
  }
);
